export default "__VITE_ASSET__7f1c5720__"